import { stripHtml } from "string-strip-html";

export const splitStringToSpeak = (content: string) => {
  content = stripHtml(content).result;

  // Split up the string and use `reduce`
  // to iterate over it
  const temp = content.split("\n").reduce(
    (acc, c: string) => {
      // Get the number of nested arrays
      const currIndex = acc.length - 1;

      // Join up the last array and get its length
      const currLen: number = acc[currIndex].join("").length;

      // If the length of that content and the new word
      // in the iteration exceeds 200 chars push the new
      // word to a new array
      if (currLen + c.length > 200) {
        acc.push([c]);
        // otherwise add it to the existing array
      } else {
        acc[currIndex].push(c);
      }
      return acc;
    },
    [[]]
  );

  // Join up all the nested arrays
  const out = temp.map((arr: string[]) => arr.join(" "));

  // Removes empty array items and return
  return out.filter((item: string) => item);
};
